import { render, staticRenderFns } from "./NavigationHeader2.vue?vue&type=template&id=554f727e&scoped=true&"
import script from "./NavigationHeader2.vue?vue&type=script&lang=js&"
export * from "./NavigationHeader2.vue?vue&type=script&lang=js&"
import style0 from "./NavigationHeader2.vue?vue&type=style&index=0&id=554f727e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554f727e",
  null
  
)

export default component.exports